// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.public-feedback__character-limit[data-v-90c78b8c] {\n  margin: -10px 0 10px 20px;\n}\n.public-feedback__note[data-v-90c78b8c] {\n  margin-bottom: 5px;\n  color: #b68e56;\n}\n.public-feedback__note a[data-v-90c78b8c] {\n  text-decoration: underline;\n}\n.public-feedback__title[data-v-90c78b8c] {\n  margin-bottom: 2px;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
